module.exports = __webpack_public_path__ + "static/media/f1141359084b3b61f3a41adbe541fdbb.f1141359.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/res/images/discordAssets/f1141359084b3b61f3a41adbe541fdbb.svg
// module id = 1237
// module chunks = 21